// automatically generated by the FlatBuffers compiler, do not modify

import { BitMaskMessage } from "../ln2/bit-mask-message";
import { OneHotMessage } from "../ln2/one-hot-message";

export enum EncodedMessageContent {
	NONE = 0,
	OneHotMessage = 1,
	BitMaskMessage = 2,
}

export function unionToEncodedMessageContent(
	type: EncodedMessageContent,
	accessor: (obj: BitMaskMessage | OneHotMessage) => BitMaskMessage | OneHotMessage | null
): BitMaskMessage | OneHotMessage | null {
	switch (EncodedMessageContent[type]) {
		case "NONE":
			return null;
		case "OneHotMessage":
			return accessor(new OneHotMessage())! as OneHotMessage;
		case "BitMaskMessage":
			return accessor(new BitMaskMessage())! as BitMaskMessage;
		default:
			return null;
	}
}

export function unionListToEncodedMessageContent(
	type: EncodedMessageContent,
	accessor: (index: number, obj: BitMaskMessage | OneHotMessage) => BitMaskMessage | OneHotMessage | null,
	index: number
): BitMaskMessage | OneHotMessage | null {
	switch (EncodedMessageContent[type]) {
		case "NONE":
			return null;
		case "OneHotMessage":
			return accessor(index, new OneHotMessage())! as OneHotMessage;
		case "BitMaskMessage":
			return accessor(index, new BitMaskMessage())! as BitMaskMessage;
		default:
			return null;
	}
}
